<template>
    <div class="w-100">
        <div class="w-100 d-flex justify-center">
            <v-progress-circular
                indeterminate
                color="primary"
                v-if="!user"
            ></v-progress-circular>
        </div>
        <div v-if="user">
            <div class="row mt-5">
                <div class="col-md-12 mb-3 d-flex justify-space-between d-flex align-center">
                    <div @click="goToUsers" class="d-flex flex-row align-center hover">
                        <v-img max-height="32px" max-width="32px" :src="$root.getSrc('/default/drop_icons/left_arrow.svg')" contain></v-img>
                        <p class="ma-0 ml-5 fw-400 fs-18">Back to all users list</p>
                    </div>
                    <div class="d-flex flex-row align-center">
                        <v-btn @click="deleteUser" v-ripple="false"  class="white--text drop-button button-primary-active ml-2" color="#D72C83">
                            Delete user
                        </v-btn>
                    </div>
                </div>
            </div>

            <div class="row drop-container pa-5 mb-5">
                <div class="col-md-12 grey-line">
                    <p class="ma-0 fs-20 fw-600">
                        User #{{user.id}}
                    </p>
                </div>

                <div class="col-md-12 mb-5">
                    <v-data-table
                        class="order-table"
                        :items="[user]"
                        :headers="headers"
                        :hide-default-footer="true"
                    >

                        <template v-slot:item.customization="{item}">
                           <span class="drop-chip" v-if="item.customization">
                               active
                           </span>
                            <span class="drop-chip">
                               inactive
                           </span>
                        </template>


                    </v-data-table>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {deleteUsers, getAdminUsers} from "@/api/user";
export default {
    computed:{
    },
    data: () => {
        return {
        loader: false,
        headers: [
            {
                text: 'Name',
                value: 'name',
                sortable: false,
            },
            {
                text: 'Email',
                value: 'email',
                sortable: false
            },
            {
                text: 'Last login',
                value: 'last_login',
                sortable: false,
            },
            {
                text: 'Customization',
                value: 'customization',
                sortable: false
            },
        ],
        user: null
    }},
    mounted() {
        this.getUser();
    },
    methods:{
        goToUsers(){
            location.href = location.origin+'/users'
        },
        getUser(){
            let obj = {
                'edit_user_id': this.$route.params.id
            }
            getAdminUsers(obj).then(res=>{
                this.user = res;
            })
        },
        deleteUser(){
            this.$confirm('Deleting user', 'Are you sure you want delete this user?',{accept: {text: 'Delete', color:'error'}, cancel: {text: 'Cancel', color: 'primary'}}).then(res => {
                this.deleteChosenUser(this.user);
            })
        },
        deleteChosenUser(user){
            this.loading = true;
            deleteUsers(user.id).then(response => {
                this.$store.commit('app/ADD_MESSAGE', {text: this.$t('User deleted successfully'), type:'info'});
                this.goToUsers();
            }).catch(e => {
                if(e.response.data.message){
                    this.$store.commit('app/ADD_MESSAGE', {text: e.response.data.message, type:'error'});
                }
                this.loading = false;
            })
        }
    }
}
</script>

<style>
.v-data-table-header th, .text-start {
    padding-left: 0!important;
}
</style>
